import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles, Theme } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    dialogCloseButton: {
        color: '#fff',
    },
    button: {
        display: 'flex',
        '& button': {
            marginRight: theme.spacing(2),
        },
    },
    header: {
        margin: 'unset',
        textAlign: 'left',
        width: '100%',
        height: pxToRem(47),
        color: '#fff',
        fontSize: pxToRem(23),
        background: 'linear-gradient(145.96deg, #C68226 20.1%, #BD7257 79.78%)',
        display: 'flex',
        flexDirection: 'row',
    },

    headerText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textTransform: 'uppercase',
        flex: 1,
    },

    headerIcon: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '& button': {
            marginRight: theme.spacing(1),
        },
    },
    paddingLeft: {
        '&.MuiGrid-item': {
            paddingLeft: theme.spacing(2.25),
        },
        '&.MuiGrid-container': {
            paddingLeft: theme.spacing(2.25),
        },
    },
}))

interface ManageProjectTeamPopupFormHeaderProps {
    onDialogClose?: VoidFunction
    variant: 'add' | 'remove'
}

const ManageProjectTeamPopupFormHeader: React.FC<ManageProjectTeamPopupFormHeaderProps> = ({
    onDialogClose,
    variant,
}) => {
    const classes = useStyles()

    return (
        <GridContainer
            className={classes.header}
            data-testid="manageProjectTeamPopupFormHeader"
        >
            <GridItem className={clsx(classes.headerText, classes.paddingLeft)}>
                {variant === 'add' ? 'Add Team Members' : 'Remove Team Members'}
            </GridItem>
            <GridItem className={classes.headerIcon}>
                <IconButton
                    aria-label="close"
                    className={classes.dialogCloseButton}
                    size="small"
                    onClick={onDialogClose}
                >
                    <CloseIcon />
                </IconButton>
            </GridItem>
        </GridContainer>
    )
}

export default ManageProjectTeamPopupFormHeader
